import React, { Component, Fragment } from "react";
import CheckAccess from "../checkAccess/CheckAccess";
import AuthRender from "../../containers/AuthRender";
import { NavLink } from "react-router-dom";
import MenuLeft from "./MenuLeft";
import { Select } from "antd";
import _ from "lodash";
import MenuTopItem from "./MenuTopItem";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";
import { COLOR_ENV, serverEnv } from "./../../configs/config";
import { roles } from "../../configs/constants";

const Option = Select.Option;

class MenuTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      theme: "main"
    };
  }

  menuTopItems = () => {
    const { menuData, currentClient, userInfos } = this.props;
    const statistiqueObj = currentClient.services.find(service => service.id === 9);
    const menuTopAccess = {
      Admin: {
        allowedValues: [1],
        value: userInfos.role_id
      },
      Statistiques: {
        allowedValues: [1],
        value: statistiqueObj.access.consultation
      }
    };

    const displayMenuTopItem = menuData => (
      <AuthRender minRole={5}>
        <MenuTopItem label={menuData.label} id={menuData.id} path={menuData.path} />
      </AuthRender>
    );

    return menuData.map((menuData, m) => {
      menuData = menuData || {};
      const { id, label, path, ...authProps } = menuData;
      return (
        <Fragment key={id}>
          <AuthRender {...authProps}>{displayMenuTopItem(menuData)}</AuthRender>
        </Fragment>
      );
    });
  };

  onChangeClient = index => {
    const { setCurrentClient, userInfos } = this.props;

    setCurrentClient(userInfos.clients[index]);
    localStorage.setItem("currentClient", JSON.stringify(userInfos.clients[index]));
  };

  displaySelect = () => {
    const { userInfos, currentClient } = this.props;
    const selectClientDefaultValue = _.isEmpty(currentClient)
      ? userInfos.clients[0].display
      : `C${currentClient.id} ${currentClient.label}`;

    return (
      <Select
        defaultValue={selectClientDefaultValue}
        style={{ width: 250 }}
        onChange={value => this.onChangeClient(value)}
      >
        {userInfos.clients.map((client, index) => (
          <Option key={client.id} value={index}>
            {client.display}
          </Option>
        ))}
      </Select>
    );
  };

  render() {
    const { authLogout, history, userInfos, currentClient } = this.props;

    return (
      <Fragment>
        <header className="p-menu-main">
          {serverEnv !== "PROD" && (
            <span
              style={{
                fontWeight: "bold",
                fontSize: 30,
                paddingLeft: 20,
                paddingRight: 20,
                backgroundColor: COLOR_ENV[serverEnv]
              }}
            >
              {serverEnv}
            </span>
          )}
          <link rel="stylesheet" type="text/css" href={`/style/themes/${this.state.theme}/style.css`} />
          <div className="p-menu-main-nav">
            <div className="p-menu-main-nav-menu">
              {!_.isEmpty(userInfos.clients) && !_.isEmpty(currentClient) && this.menuTopItems()}
            </div>
          </div>
          {serverEnv !== "PROD" && (
            <span
              style={{
                fontWeight: "bold",
                fontSize: 30,
                paddingLeft: 20,
                paddingRight: 20,
                backgroundColor: COLOR_ENV[serverEnv]
              }}
            >
              {serverEnv}
            </span>
          )}
        </header>
        <div
          className="p-menu-second"
          style={this.props.location.pathname.indexOf("/stats") !== -1 ? { height: 50 } : null}
        >
          <div className="p-menu-second-logo-container">
            <NavLink to="/">
              <div className="p-menu-second-logo"></div>
            </NavLink>
          </div>
          {this.props.location.pathname.indexOf("/stats") === -1 && (
            <MenuLeft menuData={this.props.leftBarData} {...this.props} />
          )}
          <div className="p-menu-second-user">
            <span
              style={{ display: "none" }}
              className="p-menu-second-user-ico icon-theme"
              onClick={() =>
                this.setState({
                  theme: this.state.theme === "main" ? "ecosystem" : "main"
                })
              }
            />
            <div className="p-menu-second-language" style={{ display: "none" }}>
              <img
                className="p-menu-second-language-img"
                src={
                  this.props.language === "fr"
                    ? process.env.PUBLIC_URL + "/img/lang-fr.png"
                    : process.env.PUBLIC_URL + "/img/lang-eng.png"
                }
                alt="Langue"
                onClick={() => {
                  this.props.language === "fr" ? this.props.changeLanguage("en") : this.props.changeLanguage("fr");
                }}
              />
            </div>

            {(userInfos.role_id === roles.ADMIN || userInfos.role_id === roles.DIRECTOR) && !userInfos.effectif ? (
              <div style={{ textAlign: "center", border: "1px solid black", padding: 5, margin: 2 }}>
                <strong> {`${userInfos.role_label}`}</strong>
                <br />
                -
                <br />
                {`${userInfos.fullName}`}
              </div>
            ) : (
              <div className="p-menu-second-user-img">
                <span className="p-menu-second-user-img-logo" />
                <span className="p-menu-second-user-img-infos">
                  <b>{userInfos.fullName}</b>
                  <br />
                  <br />
                  {
                    <FormattedMessage id={"Rôle"} defaultMessage={"Rôle"}>
                      {txt => <React.Fragment>{txt}</React.Fragment>}
                    </FormattedMessage>
                  }
                  : {userInfos.role_label}
                </span>
              </div>
            )}
            <AuthRender>
              <div>{!_.isEmpty(userInfos.clients) && this.displaySelect()}</div>
            </AuthRender>

            <span
              className="p-menu-second-user-ico icon-logout"
              onClick={() => {
                authLogout();
              }}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(MenuTop);



// WEBPACK FOOTER //
// src/components/menu/MenuTop.js